import { render } from "./TableWithStatus.vue?vue&type=template&id=7fe51bfe"
import script from "./TableWithStatus.vue?vue&type=script&lang=ts"
export * from "./TableWithStatus.vue?vue&type=script&lang=ts"

import "./TableWithStatus.vue?vue&type=style&index=0&id=7fe51bfe&lang=css"
script.render = render

export default script